import { CircularProgress } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import AppContext from "../../container/context";

export default function ProdutoPerto(props) {
  const history = props.history;
  const [carregando, setCarregando] = useState(false);
  const [produtoId] = useState(Number(props.match.params.id));
  const [dadosProduto, setDadosProduto] = useState({
    nome: "",
    inativacao: "",
  });
  const { notification } = useContext(AppContext);

  useEffect(() => {
    if (produtoId > 0) {
      carregarProduto();
    }
  }, []);

  const carregarProduto = () => {
    setCarregando(true);

    api
      .get("produtosPerto/carregar", { id: produtoId })
      .then((res) => {
        if (res.inativacao) res.inativacao = res.inativacao.split(" ")[0];
        setDadosProduto(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar produto");
        setCarregando(false);
      });
  };

  const salvarProduto = (params) => {
    let dadosParams = dadosProduto;
    dadosParams.nome = params.nome;
    dadosParams.inativacao = params.inativacao;
    if (produtoId > 0) dadosParams.id = produtoId;

    setDadosProduto(dadosParams);
    if (produtoId === 0) {
      api
        .put("produtosPerto/inserir", dadosParams)
        .then((res) => {
          notification("success", "Produto inserido!");
          setDadosProduto({ nome: "", inativacao: "" });
          history.push(`/app/produto-perto`);
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");

            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      api
        .post("produtosPerto/editar", dadosParams)
        .then((res) => {
          notification("success", "Produto inserido!");
          setDadosProduto({ nome: "", inativacao: "" });
          history.push(`/app/produto-perto`);
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const fDados = {
    title: produtoId === 0 ? "Novo Produto" : "Produto",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 8,
        value: dadosProduto.nome,
      },
      inativacao: {
        label: "Inativação",
        type: "date",
        space: 4,
        value: dadosProduto.inativacao,
      },
    },

    submit: {
      label: "Salvar",
      action: salvarProduto,
    },

    history,
    close: true,
  };

  return (
    <div> {carregando ? <CircularProgress /> : <Form formData={fDados} />}</div>
  );
}
